/**
 * Validación de resultados de Geocoding para dirección de facturación (tienda hormigón / cemento).
 */

export type BillingGeocodeOutcome =
  | { status: 'ok'; displayAddress: string; billingAddress: string }
  | { status: 'invalid' };

export function isValidGeocodedBillingAddress(
  respuestaG: google.maps.GeocoderResult,
  direccionOriginal: string
): boolean {
  if (respuestaG.partial_match) {
    return false;
  }

  const addressComponents = respuestaG.address_components;
  const requiredTypes = ['street_number', 'route', 'locality', 'country'] as const;
  const hasRequiredComponents = requiredTypes.every((type) =>
    addressComponents.some((comp) => comp.types.includes(type))
  );

  if (!hasRequiredComponents) {
    return false;
  }
  const direccionResult = respuestaG.formatted_address.toLowerCase();
  const splitDireccionOriginal = direccionOriginal
    .toLowerCase()
    .split(',')
    .map((term) => term.trim());
  return splitDireccionOriginal.every((term) =>
    term.length > 0 ? direccionResult.includes(term) : true
  );
}

export function resolveBillingAddressFromGeocoder(
  place: google.maps.GeocoderResult,
  concatenatedUserAddress: string
): BillingGeocodeOutcome {
  const types = place.types.filter((x) => x !== 'plus_code' && x !== 'route');
  if (types.length > 0) {
    let valid = 0;
    place.address_components.forEach((x) => {
      if (x.types.includes('administrative_area_level_1')) {
        valid += 1;
      }
      if (x.types.includes('administrative_area_level_3')) {
        valid += 1;
      }
      if (x.types.includes('route')) {
        valid += 1;
      }
      if (x.types.includes('street_number')) {
        valid += 1;
      }
    });
    if (valid === 4) {
      return {
        status: 'ok',
        displayAddress: place.formatted_address,
        billingAddress: place.formatted_address,
      };
    }
    if (
      Boolean(place.partial_match) ||
      isValidGeocodedBillingAddress(place, concatenatedUserAddress)
    ) {
      return {
        status: 'ok',
        displayAddress: concatenatedUserAddress,
        billingAddress: concatenatedUserAddress,
      };
    }
  } else if (concatenatedUserAddress) {
    return {
      status: 'ok',
      displayAddress: concatenatedUserAddress,
      billingAddress: concatenatedUserAddress,
    };
  }
  return { status: 'invalid' };
}
